import React, { useEffect, useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import SensorEdit from '@awp/components/SensorAdmin/SensorEdit';
import SensorTable from '@awp/components/SensorAdmin/SensorTable';
import { BOOTSTRAP_BREAKPOINTS, checkBreakpoint } from '@awp/helpers/UIHelper';
import { GetJson } from '@awp/helpers/fetchReact';
import { REST_API, FORM_MODE } from '@awp/constants';
import { debounce } from '@awp/helpers/Utils';
import { AwpContainer } from '../Common/AwpContainer';
import { DEFAULT_PAGE_SIZE } from '@components/table';

const SensorAdmin = (props) => {
  const location = useLocation();
  const id = location?.state?.id;
  const stateMode = location?.state?.stateMode;
  const [mode, setMode] = useState(id && stateMode ? stateMode : FORM_MODE.LIST);
  const [isMedium, setIsMedium] = useState(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
  const [isLarge, setIsLarge] = useState(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.LARGE));
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sensor, setSensor] = useState(null);
  const [search, setSearch] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [defaultPageSize, setDefaultPageSize] = useState(DEFAULT_PAGE_SIZE);

  useEffect(() => {
    setLoading(true);
    const url = REST_API.SENSOR_EQUIPMENT;
    GetJson(url)
      .then((response) => response.json())
      .then((data) => {
        setData(data);
        setFilteredData(data);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const handleResize = debounce(() => {
      setIsMedium(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
      setIsLarge(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.LARGE));
    }, 100);

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  const tableProps = {
    isMedium,
    isLarge,
    data,
    loading,
    setMode,
    mode,
    setSensor,
    search,
    setSearch,
    filteredData,
    setFilteredData,
    defaultPageSize,
    setDefaultPageSize,
  };

  const sensorEditProps = {
    setMode,
    mode,
    sensorId: sensor ? sensor.Id : id,
    data,
    setData,
    setLoading,
    loading,
  };

  return (
    <AwpContainer>
      {mode === FORM_MODE.LIST ? <SensorTable {...tableProps} /> : <SensorEdit {...sensorEditProps} />}
    </AwpContainer>
  );
};

export default SensorAdmin;
